import React, { useState, useEffect, useContext } from "react";
import { Alert, Box, Grid, TextField, Typography, Button, Paper, Checkbox, FormControlLabel, Tooltip, Chip } from '@mui/material';

import { Radio, RadioGroup, FormControl, FormLabel } from '@mui/material';
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import MenuItem from '@mui/material/MenuItem';
import Switch from '@mui/material/Switch';
import FormGroup from "@mui/material/FormGroup";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import successIcon from '../assets/payment-success-icon.png';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useMember } from '../context/MemberProfileContext';
import RetreatRulesComp from '../components/RetreatRulesComp'
import parse from 'html-react-parser';
// added imports for pretty breakdown table
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';


import PaymentComp from '../components/PaymentComp'
import PaypalComp from '../components/PaypalComp';
import { DataContext } from '../App';
import PaypalZelle from "../components/PaypalZelle";


export default function HanumanHavan() {
    const [eventData, setEventData] = useState({
        "balaviharYear": "",
        "membershipType": {
            "name": ""
        },
        status: "",
        eventType: '',
        "notes": "first event1",
        "children": [
        ],
        "medical": {
            "pcpName": "",
            "pcpMobile": "",
            "medicalInsurance": "",
            "groupNo": "",
            "idNo": "",
            "medicalNotes": "",
            "medicalConsentSignedBy": "",
            "treatmentConsentSignedBy": ""
        },
        transaction: {
            quantities: 0,
            itemPrice: 0,
            totalAmount: "",
            donationAmount: "",
            payerId: "",
            notes: "Multiple Events",
        },
        "events": [
        ],
        donationOnly: false,
        feeEnabled: 0,
        parent: {
            firstName: "",
            lastName: "",
            email: "",
            mobileNumber: ""

        }
    });
    const { accessToken, signOut } = useAuth();
    const [eventTxnsHistory, setEventTxnsHistory] = useState();
    const [studentFields, setStudentFields] = useState([]);
    const [eventFields, setEventFields] = useState([]);
    const [childEventTypes, setChildEventTypes] = useState([]);
    const [eventDescription, setEventDescription] = useState("");
    const [ticketPrice, setTicketPrice] = useState(0);
    const [eventTypeId, setEventTypeId] = useState(0);
    const [holiPrice, setHoliPrice] = useState(0);
    const [holiEventTypeId, setHoliEventTypeId] = useState(null);
    const [holiFlag, setHoliFlag] = useState(true);
    const [hchEventTypes, setHchEventTypes] = useState([]);
    const [parentEventType, setParentEventType] = useState({});
    const [sponsorship, setSponsorship] = useState(0);
    
    const [sessions, setSessions] = useState();
    const [error, setError] = useState(null);
    const [rulesAccepted, setRulesAccepted] = useState(false); // State to manage checkbox
    const API_URL = process.env.REACT_APP_API_URL;
    const navigate = useNavigate();
    const { memberships, setMemberships } = useMember();
    const [parivarMember, setParivarMember] = useState(false);
    const [feeEnabled, setFeeEnabled] = useState(0);
    const [parivarEnabled, setParivarEnabled] = useState(0);

    const { memberProfile, setMemberProfile } = useMember();
    const { eventTypes, setEventTypes } = useMember();
    const [inputFields, setInputFields] = useState(eventData.transaction);
    const [childFields, setChildFields] = useState(eventData.dayCare);
    const [medicalFields, setMedicalFields] = useState(eventData.medical);
    const [fullNames, setFullNames] = useState(memberProfile.children.map((child) => child.fullName));
    const [donation, setDonation] = useState(0);
    const [totalAmount, setTotalAmount] = useState(inputFields.quantities * inputFields.itemPrice);
    const [noOfPeople, setNoOfPeople] = useState(eventData.transaction.quantities);
    const [noOfParticipants, setNoOfParticipants] = useState(1);
    const [eventDetails, setEventDetails] = useState(0);
    //const [displayEventType, setDisplayEventType] = useState({});
    const [memBvRegdReqd, setMemBvRegdReqd] = useState(); // Membership/Balavihar registration required for event

    useEffect(() => {

        console.log("Token exists or not :", accessToken);

        if (accessToken) {
            memberProfileFetch(); // Load membership data
            eventTxnsHistoryFetch();

        } else {
            signOut();
            navigate('/');
        }
    }, [accessToken])         // Empty dependency array ensures this runs once on mount;

    //Chinmaya Parivar Member
    const [payloadData, setPayloadData] = useState({});

    //to populate registered children


    const [email, setEmail] = useState("");
    useEffect(() => {
        setEmail(memberProfile.primary.email); // Assign email from memberProfile
    }, [])         // Empty dependency array ensures this runs once on mount
    useEffect(() => {
        eventData.parent.firstName = memberProfile.primary.firstName;
        eventData.parent.lastName = memberProfile.primary.lastName;
        eventData.parent.email = memberProfile.primary.email;
        eventData.parent.mobileNumber = memberProfile.primary.mobileNumber.replace(/[-\s]/g, ''); // Remove hyphens and spaces    
    }, [])         // Empty dependency array ensures this runs once on mount 

    useEffect(() => {
        if (eventTypes && eventTypes.length > 0) {
        // Filter event types where category is 'Donation'
        const hchEventTypes = eventTypes.filter(eventType => eventType.category === 'HCH');
        const parentEventType = eventTypes.filter(eventType => eventType.eventTypeId === hchEventTypes[0].parentEventTypeId)[0];

        setParentEventType(parentEventType);
        setHchEventTypes(hchEventTypes); // <-- Add this state to hold filtered events

        // Optionally, set a default event type if needed
        if (hchEventTypes.length > 0) {
            eventData.balaviharYear = parentEventType.eventYear;
            eventData.eventType = parentEventType.name;
        }
        /*
        if (eventTypes && eventTypes.length > 0) {
            // Filter the event types to find the one with the name 'HanumanHavan'            
            const selectedEventType = (eventTypes.find((eventType) => eventType.name === 'HanumanHavan'));
            setDisplayEventType(selectedEventType);

            if (selectedEventType) {
                //console.log("Event Type found with the name 'HanumanHavan':", selectedEventType);
                eventData.balaviharYear = (selectedEventType.eventYear); // Set the balavihar year
                eventData.eventType = (selectedEventType.name); // Set the event description
                setTicketPrice(selectedEventType.price); // Set the ticket price
                setEventTypeId(selectedEventType.eventTypeId); // Set the event type ID          

            } else {
                //console.log("No event type found with the name 'HanumanHavan'");
                //setCulturalEventTypes([]); // Set to an empty array if no matching record is found
            } */
        }

    }, [eventTypes]);


    const total = () => {
        inputFields.donationAmount = donation;
        inputFields.totalAmount = totalAmount;
        eventData.transaction = inputFields;
    }
    total();

    useEffect(() => {

        eventData.transaction.itemPrice = ticketPrice;
        eventData.transaction.quantities = noOfPeople;

        if (feeEnabled) {
            setTotalAmount(((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation)) * 1.03).toFixed(2));
        } else {
            setTotalAmount((parseInt(noOfPeople) * parseInt(ticketPrice) + parseInt(donation)) * 1.00);
        }

        eventData.transaction.totalAmount = totalAmount;
        // build events array only when corresponding quantities > 0
        const memberId = memberProfile?.primary?.memberId || null;
        const eventsArray = [];
        const ticketQty = parseInt(noOfPeople || 0, 10);
        if (ticketQty >= 0) {
            eventsArray.push({
                memberId: memberProfile.primary.memberId,
                eventTypeId: eventTypeId,
                quantities: ticketQty,
                participants: noOfParticipants
            });
        }

        // update eventData.events via setter to keep React state consistent
        setEventData(prev => ({ ...prev, events: eventsArray, donationOnly: ticketQty === 0 && donation > 0 ? true : false }));
        console.log("Run 1 calculate price :", eventData, (eventData.events), ticketPrice, totalAmount);

    }, [noOfPeople, donation, sponsorship, noOfParticipants, feeEnabled, parivarEnabled, ticketPrice, memberships.totalAmountPaid, memberships.status, parivarMember]);

const handleSelectSponsorship = (e) => {
    // radio value is string, convert to number before calculations
        const selectedId = parseInt(e.target.value, 10);
        setSponsorship(selectedId);

        // Find the selected event type object from hchEventTypes
        const selectedEventType = hchEventTypes.find(
            (eventType) => Number(eventType.eventTypeId) === selectedId
        );
        if (selectedEventType) {
            setEventTypeId(selectedEventType.eventTypeId);

            // Set ticketPrice and noOfPeople for correct calculations
            setTicketPrice(selectedEventType.price);
            setNoOfPeople(1);

            // Update eventData.events with the selected event
            console.log("Selected Sponsorship Event Type id:", selectedEventType.eventTypeId);

            setEventData(prev => ({
                ...prev,
                events: [{
                    memberId: memberProfile.primary.memberId,
                    eventTypeId: selectedEventType.eventTypeId,
                    quantities: 1 // Set quantities to 1 for sponsorship
                }],
                transaction: {
                ...prev.transaction,
                quantities: 1, // <-- Set quantities to 1 when an event is selected
                itemPrice: selectedEventType.price, // <-- Set itemPrice based on selected event
            }
            }));
        }
        console.log("Sponsorship Amount :", e.target.value, eventData.events);
    }

    const eventTxnsHistoryFetch = async () => {
        let response, data;
        try {
            const response = await fetch(`${API_URL}/gquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cmdfw-jwt-token': `${accessToken}`,
                },
                body: JSON.stringify({
                    query: `
                            query {
                              eventsHistory {
                                  events {
                                      memEventsId
                                      status
                                      startDate
                                      endDate
                                      memberEntity {
                                          memberId
                                          memberType
                                          fullName
                                      }
                                      eventTypesEntity {
                                          eventTypeId
                                          name
                                          eventYear
                                      }
                                      transactionEntity {
                                          transactionId
                                          totalAmount
                                          paymentStatus
                                          createdAt
                                      }
                                  }
                                }
                            }
                          `,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                console.log("Event history data API call:", response, data.data.eventsHistory.events);

                setEventTxnsHistory(data.data.eventsHistory.events);
            } else {
                if (response.status === 403) {
                    const errorData = await response.json();
                    throw new Error(errorData.message || 'OTP expired');
                    //handleLogout(); // Logout user
                } else {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Membership fetch failed');
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching Event Txns History :", error);
            //signOut();
            //navigate('/');
        }
    };

    function handlePeople(e) {
        setNoOfPeople(parseInt(e.target.value));
    }
    function handleParticipantsChange(e) {
        setNoOfParticipants(parseInt(e.target.value));
    }

    const handleLogout = () => {
        signOut();
        navigate('/');
    };

    const memberProfileFetch = async () => {
        console.log("Membership profile fetch", accessToken);
        let response, data;
        try {
            //const response = await fetch('https://membership.cmdfw.org/api/gquery', {
            const response = await fetch(`${API_URL}/gquery`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-cmdfw-jwt-token': `${accessToken}`,
                },
                body: JSON.stringify({
                    query: `
                          query {
                            memberships {
                                balaviharYear
                                balaviharPeriod
                                status
                                totalAmountPaid
                                membershipTypes {
                                    membershipTypeId
                                    name
                                    startDate
                                    endDate
                                    bvPrice
                                    childQuantities
                                }
                                availableSessions {
                                    sessionId
                                    center
                                    sessionName
                                    grades {
                                        gradeId
                                        grade
                                    }
                                }
                                registeredSessions{
                                    bvRegistrationId
                                    regStartDate
                                    regEndDate
                                    status
                                    memberEntity{
                                        firstName
                                        lastName
                                        fullName
                                    }
                                    sessionEntity {
                                        sessionId
                                        center
                                        sessionName
                                    }
                                    gradeEntity{
                                        gradeId
                                        grade
                                    }
                                }
                                currentMembership {
                                    membershipId
                                    startDate
                                    endDate
                                    status
                                    notes
                                    bvYear
                                    createdAt 
                                    createdBy 
                                    membershipTypesEntity{
                                        membershipTypeId
                                        name
                                        startDate
                                        endDate
                                    }
                                    transactionEntity {
                                        transactionId
                                        eventTypesEntity {
                                            eventTypeId
                                            name
                                            eventYear
                                        }
                                        totalAmount
                                        paymentStatus
                                        createdAt 
                                        createdBy 
                                    }
                                }
                            }
                          }
                        `,
                }),
            });

            const data = await response.json();
            if (response.ok) {
                setMemberships(data.data.memberships);
                console.log("Membership data after API call:", data, response);
            } else {
                if (response.status === 403) {
                    const errorData = await response.json();
                    handleLogout(); // Logout user
                    throw new Error(errorData.message || 'OTP expired');
                } else {
                    if (!response.ok) {
                        const errorData = await response.json();
                        throw new Error(errorData.message || 'Membership fetch failed');
                    }
                }
            }
        } catch (error) {
            console.error("Error fetching Membership Profile :", error);
            signOut();
            //navigate('/');
        }
    };


    const checkoutHandler = (e) => {
        e.preventDefault();
        setError(null);
        // Skip payment if total amount is zero
        if (totalAmount > 0) {
            eventData.status = "pending";
        } else {
            eventData.status = "paid";
            setSuccess(true); // Skip payment if total amount is zero
        }
        setPayloadData(eventData);

        //    console.log("transaction before sent to SQS:", (inputFields));
        if (sendToServer()) {
            console.log("checkout true");
            //setCheckout(true);
        } else {
            //setCheckout(false);
            console.log("checkout false");
        }
    };
    async function sendToServer() {
        const maxRetries = 3; // Maximum number of retries
        let attempt = 0;
        let url_link = `${API_URL}/events`;
        console.log("transaction before sent to Database:", eventData, url_link);


        while (attempt < maxRetries) {
            try {
                //const response = await fetch(`${API_URL}/events`, {
                const response = await fetch(url_link, {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        "x-cmdfw-jwt-token": `${accessToken}`,
                    },
                    body: JSON.stringify(eventData),
                });
                console.log('API response:', response.data);
                if (response.ok) {
                    setCheckout(true);
                    return true; // Success
                }
                if (response.status === 403) {
                    const errorData = await response.json();
                    handleLogout(); // Logout user
                    throw new Error(errorData.message || 'OTP expired');
                } else {
                    const errorData = await response.json();
                    console.error('API Error:', errorData);
                    setError(errorData.message);
                    return false; // API call failed
                    //throw new Error(errorData.message || 'API call failed');
                }
            } catch (error) {
                console.error(`Attempt ${attempt + 1} failed:`, error);
                attempt++;

                if (attempt >= maxRetries) {
                    console.error('All retry attempts failed.');
                    setCheckout(false);
                    setError("Failed to send data to the server. Please try again later.");
                    return false; // Return false after all retries fail
                }

                console.log(`Retrying API call... (${attempt}/${maxRetries})`);

            }
        }
    }


    function feeSwitchHandler(e) {
        setError(null); // Clear any existing errors
        setFeeEnabled(e.target.checked);
        eventData.feeEnabled = e.target.checked;
    }
    function checkOutEnableHandler(e) {
        setError(null); // Clear any existing errors
        setRulesAccepted(e.target.checked)
    }
    function handleBack() {
        setCheckout(false);
    }

    function handleDonation(e) {
        setInputFields({ ...inputFields, [e.target.name]: parseInt(e.target.value) });
        if (e.target.value >= 0) {
            setDonation(parseInt(e.target.value));
        }
    };

    const handleCancel = () => {
        navigate('/EventTypesForm');
        // Add any additional save logic here, such as API calls
    };

    const initialOptions = {
        clientId: process.env.REACT_APP_PROD_CLIENT_ID,
        currency: "USD",
        intent: "capture",
        "disable-funding": "paylater",
    };

    const [errorMessage, setErrorMessage] = useState('')
    const [orderId, setOrderId] = useState(false)


    const [success, setSuccess] = useState(false)
    const [checkout, setCheckout] = useState(false)

    // add these computed line-item values before return
    const ticketQtyNum = parseInt(noOfPeople || 0, 10);
    const ticketUnit = parseFloat(ticketPrice || 0);
    const ticketAmount = Number((ticketQtyNum * ticketUnit).toFixed(2));


    const donationAmountNum = Number(parseFloat(donation || 0).toFixed(2));

    const subtotal = Number((ticketAmount + donationAmountNum).toFixed(2));
    const feeAmount = feeEnabled ? Number((subtotal * 0.03).toFixed(2)) : 0;
    const computedTotal = Number((subtotal + feeAmount).toFixed(2));
    return (
        <div>
            <Grid item xs={12} sm={12}>
                <Typography variant="h6" align="center" gutterBottom>
                    {'CMDFW Registration System'}
                </Typography>
            </Grid>

            <form onSubmit={checkoutHandler}>
                <Grid container direction="column" alignItems="center" >
                    {
                        checkout ?
                            success ?
                                <Grid item>
                                    <img src={successIcon} className="Success-icon" alt="logo" />
                                    <Typography variant="h5" align="center" gutterBottom>
                                        {'Thank You for the Registration'}
                                    </Typography>
                                    <Box sx={{ width: '100%', maxWidth: 500 }}>
                                        <Typography variant="body2" align="left" gutterBottom>
                                            You will receive an email confirmation to this address <b> [ {email} ] </b>
                                        </Typography>
                                    </Box>
                                </Grid>
                                :

                                <Grid item>
                                    <PaypalZelle eventData={eventData} setSuccess={setSuccess} payloadData={payloadData} />

                                    <span>
                                        <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} onClick={() => handleBack()}>Back</Button>
                                    </span>
                                </Grid>
                            :
                            <div>
                                <Grid item xs={12} sm={12}>
                                    <Paper elevation={3}>
                                        <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                            <Grid item>
                                                <Box sx={{ width: '100%', minWidth: 300 }}>
                                                    <Typography variant="body2" align="left" gutterBottom>
                                                        <div>{parse(parentEventType.desc || "")}</div><br />
                                                        <div><br /></div>
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                        </Paper>
                                    </Paper>
                                </Grid>
                                <div><br /></div>
                                <Grid item xs={12} sm={12}>
                                    {
                                        memberships.status === "ACTIVE" ?
                                            (
                                                <div>
                                                    <div>Membership status is <b>Active</b> for the period: <b>{memberships.balaviharPeriod}</b></div>
                                                    <div>Membership Type : <b>{memberships.currentMembership.membershipTypesEntity.name}</b></div>
                                                    <div><br /></div>
                                                </div>
                                            )

                                            :
                                            memBvRegdReqd && memberships.status !== "ACTIVE" &&
                                            (
                                                <div><b>Membership expired.</b>
                                                    <div><b>RENEW</b> the membership for the period: <b>{memberships.balaviharPeriod}</b></div>
                                                    <div><br /></div>
                                                    <Grid item xs={12} sm={12}>
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#dfe7e7', color: 'black' }} elevation={3}>
                                                                <Grid item>
                                                                    <Box sx={{ width: '100%', minWidth: 300 }}>
                                                                        <Typography variant="body2" align="left" gutterBottom>

                                                                            <div><b>Your Membership has expired. Please RENEW your membership before registering for Labor Day Retreat. </b></div>

                                                                        </Typography>
                                                                    </Box>
                                                                </Grid>
                                                            </Paper>
                                                        </Paper>
                                                    </Grid>
                                                    <Grid item>
                                                        <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography variant="body2" align="center" gutterBottom>
                                                            If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                                        </Typography>
                                                    </Grid>

                                                </div>

                                            )
                                    }
                                </Grid>
                                <div><br /></div>
                                <Grid item xs={12} sm={12}>
                                    {
                                        (memBvRegdReqd && memberships.status === "ACTIVE") || !memBvRegdReqd ?
                                            <Grid container alignItems="center" >
                                                <Grid container alignItems="left" spacing={2}>
                                                    <Grid item xs={12} sm={12}>
                                                        <Box
                                                            sx={{
                                                                width: '100%',
                                                                borderRadius: 2,
                                                                bgcolor: 'background.paper',
                                                                transition: 'transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
                                                                border: '2px solid transparent',
                                                                '&:hover': {
                                                                    transform: 'translateY(-6px)',
                                                                    borderColor: '#ff9800', // orange
                                                                    boxShadow: 6
                                                                },
                                                                p: 1.25
                                                            }}
                                                        >
                                                        <Paper elevation={3}>
                                                            <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                                <Typography variant="h7" align="left" gutterBottom>
                                                                    <b>Hanuman Chalisa Havan Participation Sponsorship</b>
                                                                </Typography>
                                                            </Paper>
                                                            <div><br /></div>

                                                            <Grid item xs={12} sm={12}>
                                                                <FormControl>
                                                                    <FormLabel id="donation-radio-buttons-group-label">Select Sponsorship</FormLabel>
                                                                    <RadioGroup
                                                                        aria-labelledby="donation-radio-buttons-group-label"
                                                                        value={sponsorship}
                                                                        onChange={handleSelectSponsorship}
                                                                        name="donation-radio-buttons-group"
                                                                    >
                                                                        {hchEventTypes && hchEventTypes.map((eventType) => (
                                                                            <FormControlLabel
                                                                                key={eventType.eventTypeId}
                                                                                value={String(eventType.eventTypeId)}
                                                                                control={<Radio />}
                                                                                label={`$${eventType.price} (${eventType.name})`}
                                                                            />
                                                                        ))}
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </Grid>
                                                            <div><br /></div>



                                                        </Paper>
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                                            <div><br /></div>

                                              
                                            </Grid>
                                            : ""}

                                </Grid>

                                <Paper elevation={3}>
                                    <Grid item xs={12} sm={12}>

                                        <Box
                                            sx={{
                                                width: '100%',
                                                borderRadius: 2,
                                                bgcolor: 'background.paper',
                                                transition: 'transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
                                                border: '2px solid transparent',
                                                '&:hover': {
                                                    transform: 'translateY(-6px)',
                                                    borderColor: '#ff9800', // orange
                                                    boxShadow: 6
                                                },
                                                p: 1.25
                                            }}
                                        >

                                            <Paper elevation={3}>
                                                <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                    <Typography variant="h7" align="left" gutterBottom>
                                                        <b>Number of Participants in the family</b>
                                                    </Typography>
                                                </Paper>
                                            </Paper>
                                            <div><br /></div>

                                            <Paper elevation={3}>
                                                <TextField
                                                    fullWidth
                                                    number
                                                    id="tickets"
                                                    label="Enter Number of Participants"
                                                    type="number"
                                                    inputProps={{ min: 1, max: 10 }}
                                                    name="quantities"
                                                    variant="outlined"
                                                    value={noOfParticipants}
                                                    onChange={handleParticipantsChange}
                                                />

                                            </Paper>
                                        </Box>
                                    </Grid>
                                </Paper>
                                <div><br /></div>

                                {
                                    (memBvRegdReqd && memberships.status === "ACTIVE") || !memBvRegdReqd ? (
                                        <Grid item xs={12} sm={12}>
                                            <div><br /></div>
                                            <Paper elevation={3}>
                                                <Paper style={{ padding: '16px', backgroundColor: '#673ab7', color: 'white' }} elevation={3}>
                                                    <Typography variant="h7" align="left" gutterBottom>
                                                        <b>Payment Information</b>
                                                    </Typography>
                                                </Paper>
                                                <div><br /></div>

                                                <div><br /></div>
                                                <Grid container direction="row" spacing={2} >
                                                    <Grid item xs={12} sm={6}>
                                                        <TextField
                                                            fullWidth
                                                            number
                                                            id="donation"
                                                            label="Additional Donation ($)"
                                                            type="number"
                                                            name="donation"
                                                            variant="standard"
                                                            value={donation}
                                                            onChange={handleDonation}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} sm={12}>
                                                        <FormGroup>
                                                            <FormControlLabel control={<Checkbox checked={feeEnabled} />} label="Add 3% to cover for CC fees"
                                                                value={feeEnabled} size="small" onChange={feeSwitchHandler} />
                                                        </FormGroup>
                                                    </Grid>
                                                    {/* prettier payment breakdown table */}
                                                    <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
                                                        {/* Floating total amount box styled like payment info */}
                                                        <Box
                                                            sx={{
                                                                width: '100%',
                                                                borderRadius: 2,
                                                                bgcolor: 'background.paper',
                                                                transition: 'transform 200ms ease, box-shadow 200ms ease, border-color 200ms ease',
                                                                border: '2px solid transparent',
                                                                '&:hover': {
                                                                    transform: 'translateY(-6px)',
                                                                    borderColor: 'primary.main',
                                                                    boxShadow: 6
                                                                },
                                                                p: 1.25
                                                            }}
                                                        >
                                                            {/* small header to match Payment Information styling */}
                                                            <Paper elevation={0} sx={{ bgcolor: '#673ab7', color: 'white', px: 1.5, py: 0.75, borderRadius: 1 }}>
                                                                <Typography variant="subtitle2"><b>Payment Summary</b></Typography>
                                                            </Paper>
                                                            <TableContainer component={Paper} variant="outlined" sx={{ overflow: 'hidden' }}>
                                                                <Table size="small" aria-label="payment breakdown">
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell
                                                                                sx={{
                                                                                    bgcolor: '#f3f4f6',
                                                                                    color: 'text.primary',
                                                                                    fontWeight: 800,
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.08em',
                                                                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                                                }}
                                                                            >
                                                                                Item
                                                                            </TableCell>
                                                                            <TableCell
                                                                                align="right"
                                                                                sx={{
                                                                                    bgcolor: '#f3f4f6',
                                                                                    color: 'text.primary',
                                                                                    fontWeight: 800,
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.08em',
                                                                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                                                }}
                                                                            >
                                                                                Unit
                                                                            </TableCell>
                                                                            <TableCell
                                                                                align="right"
                                                                                sx={{
                                                                                    bgcolor: '#f3f4f6',
                                                                                    color: 'text.primary',
                                                                                    fontWeight: 800,
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.08em',
                                                                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                                                }}
                                                                            >
                                                                                Qty
                                                                            </TableCell>
                                                                            <TableCell
                                                                                align="right"
                                                                                sx={{
                                                                                    bgcolor: '#f3f4f6',
                                                                                    color: 'text.primary',
                                                                                    fontWeight: 800,
                                                                                    textTransform: 'uppercase',
                                                                                    letterSpacing: '0.08em',
                                                                                    borderBottom: '2px solid rgba(0,0,0,0.08)'
                                                                                }}
                                                                            >
                                                                                Amount
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {ticketQtyNum > 0 && (
                                                                            <TableRow>
                                                                                <TableCell>Hanuman Chalisa Havan</TableCell>
                                                                                <TableCell align="right">${ticketUnit.toFixed(2)}</TableCell>
                                                                                <TableCell align="right">{ticketQtyNum}</TableCell>
                                                                                <TableCell align="right">${ticketAmount.toFixed(2)}</TableCell>
                                                                            </TableRow>
                                                                        )}

                                                                        {donationAmountNum > 0 && (
                                                                            <TableRow>
                                                                                <TableCell>Additional Donation</TableCell>
                                                                                <TableCell align="right">—</TableCell>
                                                                                <TableCell align="right">1</TableCell>
                                                                                <TableCell align="right">${donationAmountNum.toFixed(2)}</TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                        {feeAmount > 0 && (
                                                                            <TableRow>
                                                                                <TableCell>Credit Card Fee (3%)</TableCell>
                                                                                <TableCell align="right">—</TableCell>
                                                                                <TableCell align="right">1</TableCell>
                                                                                <TableCell align="right">${feeAmount.toFixed(2)}</TableCell>
                                                                            </TableRow>
                                                                        )}


                                                                        <TableRow>
                                                                            <TableCell colSpan={3} align="right"><Typography sx={{ fontWeight: 900, fontSize: 16 }}>Total</Typography></TableCell>
                                                                            <TableCell align="right"><Typography sx={{ fontWeight: 900, fontSize: 16 }}>${computedTotal.toFixed(2)}</Typography></TableCell>
                                                                        </TableRow>
                                                                    </TableBody>
                                                                </Table>
                                                            </TableContainer>

                                                            <Grid item xs={12}>
                                                                <Box sx={{
                                                                    p: 1,
                                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                                    borderRadius: 4,
                                                                    color: 'white',
                                                                    textAlign: 'center',
                                                                    border: '2px solid rgba(255, 255, 255, 0.2)'
                                                                }}>
                                                                    <Typography variant="h5" sx={{ fontWeight: 700 }}>
                                                                        Total Amount: ${totalAmount}
                                                                    </Typography>
                                                                </Box>
                                                            </Grid>




                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Paper>

                                            <div><br /></div>
                                            <Grid container direction="row" spacing={5}>
                                                <Grid item>
                                                    <Typography variant="body2" align="center" gutterBottom>
                                                        <b>Waiver Statement (Please read and agree to the waiver statement before you proceed) :</b> <a href="https://membership.cmdfw.org/docs/cmdfw-waiver.pdf" target="_blank" rel="noopener noreferrer"> Open PDF </a>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                            <Grid container direction="row" spacing={5}>
                                                <Grid item>
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={rulesAccepted}
                                                                onChange={checkOutEnableHandler}
                                                                name="rulesAccepted"
                                                                color="primary"
                                                            />
                                                        }
                                                        label="I accept the rules and policies"
                                                    />
                                                </Grid>
                                            </Grid>

                                            <Grid container direction="row" spacing={2}>

                                                <Grid item>
                                                    <Button onClick={handleCancel} variant="contained" sx={{ mt: 3, mb: 2 }}>Cancel</Button>
                                                </Grid>
                                                <Grid item>
                                                    <Tooltip title={!rulesAccepted ? "Please accept the rules and policies" : ""}>
                                                        <span>
                                                            <Button type="submit" variant="contained" sx={{ mt: 3, mb: 2 }} disabled={!rulesAccepted}>Checkout</Button>
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                                {error && (
                                                    <Grid item xs={12}>
                                                        <Alert severity="error">{error}</Alert>
                                                    </Grid>
                                                )}
                                            </Grid>
                                            <Grid container direction="row" spacing={5}>
                                                <Grid item>
                                                    <Typography variant="body2" align="center" gutterBottom>
                                                        If you have any questions, please contact us at <a href="mailto:membership@cmdfw.org">membership@cmdfw.org</a>
                                                    </Typography>
                                                </Grid>
                                            </Grid>
                                        </Grid>) : ""}
                            </div>
                    }
                </Grid>
            </form>
        </div >
    );
}